import { CancelOutlinedIcon, CheckCircleOutlineRoundedIcon, Chip, Text } from '@shared/components';

export interface ExamEventExamineeResultLabelProps {
  variant?: 'passed' | 'failed';
}

export default function ExamEventExamineeResultLabel(
  props: Readonly<ExamEventExamineeResultLabelProps>,
) {
  const { variant } = props;
  switch (variant) {
    case 'passed':
      return (
        <Chip
          icon={
            <CheckCircleOutlineRoundedIcon
              sx={(theme) => ({
                color: theme.palette.success.main,
                '&.MuiChip-icon': {
                  fontSize: '1rem',
                },
              })}
            />
          }
          label={
            <Text
              variant='body2Semibold'
              sx={(theme) => ({
                ml: theme.spacing(1),
                justifyItems: 'center',
              })}
            >
              Pass
            </Text>
          }
          color='success'
          variant='outlined'
          size='small'
          sx={(theme) => ({
            pl: theme.spacing(2.5),
            pr: theme.spacing(3),
            color: theme.palette.success.dark,
            borderColor: theme.palette.success.main,
            width: '76px',
          })}
        />
      );

    case 'failed':
      return (
        <Chip
          icon={
            <CancelOutlinedIcon
              sx={(theme) => ({
                color: theme.palette.error.main,
                '&.MuiChip-icon': {
                  fontSize: '1rem',
                },
              })}
            />
          }
          label={
            <Text
              variant='body2Semibold'
              sx={(theme) => ({
                ml: theme.spacing(1),
                justifyItems: 'center',
              })}
            >
              Fail
            </Text>
          }
          color='error'
          variant='outlined'
          size='small'
          sx={(theme) => ({
            pl: theme.spacing(2.5),
            pr: theme.spacing(3),
            color: theme.palette.error.dark,
            borderColor: theme.palette.error.main,
            width: '76px',
          })}
        />
      );
    default:
      return '-';
  }
}
